import React from 'react';
import Button from '../../../../generic-components/Button';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';

interface IProps {
  toggleState: boolean;
  toggle: () => void;
  buttonId: string;
  styles?: string;
  disabled?: boolean;
  isSpinner?: boolean;
}

const ToggleButton = ({ toggleState, toggle, buttonId, styles, disabled, isSpinner = true }: IProps) => (
  <Button
    disable={disabled}
    id={buttonId}
    childElement={
      disabled && isSpinner ? (
        <Spinner spinnerColor={SpinnerColor.Blue} width='1rem' height='1rem' />
      ) : (
        <div
          id='toggler'
          className={`w-[18px] h-[18px] rounded-full ${toggleState ? 'border border-action03 mr-[1px]' : 'border border-bw03'} bg-bw00`}
        />
      )
    }
    onClick={toggle}
    className={`${styles || ''} w-[36px] h-[20px] rounded-2xl flex items-center ml-auto ${disabled ? 'flex-row bg-bw02 border border-bw03' : toggleState ? 'flex-row-reverse bg-action03' : 'flex-row bg-bw02 border border-bw03'}`}
  />
);

export default ToggleButton;
